import Chatbotlogo from "../../assets/images/chatbot.svg";
import { useAuth } from "context/AuthContext";
import chrome from "../../assets/images/chrome.webp";
import firefox from "../../assets/images/firefox.webp";
import appStore from "../../assets/images/app-store.svg";
import googlePlay from "../../assets/images/google-play-store.svg";
import { Tooltip } from "@nextui-org/react";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import {
  PiAppleLogoDuotone,
  PiAndroidLogoDuotone,
  PiGoogleChromeLogoDuotone,
  PiPuzzlePieceDuotone,
  PiYoutubeLogoDuotone,
  PiDiscordLogoDuotone,
  PiListChecksDuotone,
  PiChartLineDuotone,
  PiBookOpenUserDuotone,
  PiBookBookmarkDuotone,
  PiArrowUpRightBold,
} from "react-icons/pi";
import { IoIosArrowForward } from "react-icons/io";

export default function Home() {
  const { user } = useAuth();
  return (
    <div className="min-h-screen flex flex-col md:flex-row">
      {/* Right Section */}
      <main className="flex-1 max-w-screen-lg mx-auto flex flex-col my-[68px] md:my-[60px]">
        <section className="">
          <div className=" mx-auto pt-6">
            <h3 className=" flex text-xl items-center gap-2 font-semibold">Welcome, {user?.name || user?.first_name || user?.username}</h3>
            <p className="text-gray-500 text-sm">Lets have a look at the things you can do with YourGPT.</p>
          </div>
        </section>
        <div className=" mx-auto w-full ">
          <div className="bg-white rounded-xl p-10 mt-5">
            <div className="">
              <a href={"https://chatbot.yourgpt.ai"} rel="noreferrer" target="_blank">
                <div className="flex  justify-between gap-2 items-start w-full">
                  <div className="bg-primary1/10 p-2 rounded-full w-fit ">
                    <img className="h-10" src={Chatbotlogo} alt="chatbot-logo" />
                  </div>
                  <a
                    href={"https://chatbot.yourgpt.ai"}
                    rel="noreferrer"
                    target="_blank"
                    className="bg-primary1/20 text-primary1 font-medium text-sm border-1 py-2 px-4 rounded-xl hover:ring-2 hover:ring-primary1/80 ring-1 w-fit cursor-pointer group transition-all duration-500 min-w-36 relative  flex justify-center items-center"
                  >
                    Access Now
                    <IoIosArrowForward className="h-4 group-hover:translate-x-0 -translate-x-2 mr-2 absolute opacity-0 group-hover:opacity-100 group-hover:ml-1 transition-all right-0" />
                  </a>
                </div>
                <div>
                  <h3 className="text-lg font-semibold">YourGPT</h3>
                  <p className="text-foreground-500 text-sm">AI First platform for Complete Customer Support, Sales, and Automation</p>
                </div>
              </a>
            </div>

            <div className="mt-10 ">
              <div className="text-foreground-500 text-sm mb-2">Mobile Apps</div>
              <div className="flex items-center gap-5">
                {ADDONS.map((item) => (
                  <Tooltip
                    content={item.label}
                    placement="bottom"
                    classNames={{
                      content: "text-xs",
                    }}
                  >
                    <a href={item.url} rel="noreferrer" target="_blank" className="text-foreground-600/85 hover:text-primary1 transition-all ">
                      <img src={item.imageUrl} alt={item.label} className="size-6" />
                    </a>
                  </Tooltip>
                ))}
              </div>
            </div>
          </div>

          <div className="mt-14">
            <div className="">
              <h3 className="text-lg font-semibold">Resources</h3>
              <p className="text-gray-500 text-sm">Find useful resources to help you get started with YourGPT.</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mt-4">
              {RESOURCES.map((item) => (
                <a href={item.url} rel="noreferrer" target="_blank" className="bg-white rounded-xl p-4 hover:shadow-[0_5px_10px_rgba(0,0,0,0.05)] hover:translate-y-[-2px] transition-all group">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-2">
                      <div className={`p-1.5 rounded-full ${item.classNames}`}>
                        <item.icon className={`size-5`} />
                      </div>
                      <span className="font-medium">{item.label}</span>
                    </div>
                    <PiArrowUpRightBold className="size-4 self-start opacity-0 group-hover:opacity-100 transition-all duration-300 group-hover:translate-x-[2px] group-hover:translate-y-[-2px] text-foreground-600/90" />
                  </div>
                  <p className="text-foreground-500 text-sm mt-2">{item.description}</p>
                </a>
              ))}
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

const RESOURCES = [
  {
    label: "Cookbook",
    icon: PiBookBookmarkDuotone,
    description: "Step-by-step guides, best practices, and advanced recipes for YourGPT",
    url: "https://help.yourgpt.ai/category/cookbook",
    classNames: "bg-primary1/10 text-primary1",
  },
  {
    label: "Youtube Channel",
    icon: PiYoutubeLogoDuotone,
    description: "Watch tutorials, product demos, and more on our YouTube channel",
    url: "https://www.youtube.com/@YourGPTAI",
    classNames: "bg-red-500/10 text-red-500",
  },
  {
    label: "Join our Discord",
    icon: PiDiscordLogoDuotone,
    description: "Join our community on Discord to get help, share ideas, and connect with other users",
    url: "https://discord.com/invite/z8PBs5ckcd",
    classNames: "bg-violet-500/10 text-violet-500",
  },
  {
    label: "Documentation",
    icon: PiBookOpenUserDuotone,
    description: "Comprehensive guides and API references to help you build with YourGPT",
    url: "https://docs.yourgpt.ai",
    classNames: "bg-blue-500/10 text-blue-500",
  },
  {
    label: "Changelogs",
    icon: PiListChecksDuotone,
    description: "Track the latest features, bug fixes, and improvements in YourGPT",
    url: "https://docs.yourgpt.ai/changelogs",
    classNames: "bg-yellow-500/10 text-yellow-500",
  },
  {
    label: "Status",
    icon: PiChartLineDuotone,
    description: "Monitor system status, uptime, and performance metrics",
    url: "https://status.yourgpt.ai",
    classNames: "bg-green-500/10 text-green-500",
  },
];

const ADDONS = [
  {
    label: "iOS App",
    icon: PiAppleLogoDuotone,
    imageUrl: appStore,
    url: "https://apps.apple.com/in/app/your-ai-chatbot/id6499470819",
  },
  {
    label: "Android App",
    icon: PiAndroidLogoDuotone,
    imageUrl: googlePlay,
    url: "https://play.google.com/store/apps/details?id=com.yourgpt.chatbot",
  },
  // {
  //   label: "Chrome Extension",
  //   icon: PiGoogleChromeLogoDuotone,
  //   imageUrl: chrome,
  //   url: "https://chromewebstore.google.com/detail/yourgpt-ai/bhcadnbfklkhecfjnhiphdijgnlddegg?hl=en-US&utm_source=ext_sidebar",
  // },
  // {
  //   label: "Firefox Extension",
  //   icon: PiPuzzlePieceDuotone,
  //   imageUrl: firefox,
  //   url: "https://addons.mozilla.org/en-US/firefox/addon/yourgpt-ai-knowledgebase-agent/?utm_source=addons.mozilla.org&utm_medium=referral&utm_content=search",
  // },
];
